var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { EditorActions } from 'app/stores/editor/actions';
import { projectSlice } from 'app/stores/project';
import { sleep } from 'app/utils/varia';
export const clonePage = createAsyncThunk('project/clonePage', (props, { dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    const { id, keepItems } = props;
    dispatch(projectSlice.actions.duplicatePage({ id, keepItems }));
    yield sleep(200);
    dispatch(EditorActions.showToast({
        message: 'Slide duplicated',
        variant: 'positive',
    }));
}));
